import { render, staticRenderFns } from "./NewSnapshot.vue?vue&type=template&id=6e0b10df&scoped=true&"
import script from "./NewSnapshot.vue?vue&type=script&lang=js&"
export * from "./NewSnapshot.vue?vue&type=script&lang=js&"
import style0 from "./NewSnapshot.vue?vue&type=style&index=0&id=6e0b10df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0b10df",
  null
  
)

export default component.exports